/* TMPG — Selected Works
 * A visitor marks works while browsing; the list is kept in this browser
 * (localStorage) and can be kept for later, shared as a link, or sent to the
 * gallery from the Selected Works page.
 *
 * Storage: localStorage['tmpg_selected_works'] = [{ h: handle, v: 'size label', t: timestamp }]
 * Config:  window.TMPG_SW = { url: '/pages/selected-works' }  (set in snippets/tmpg-selected-works-init.liquid)
 */
(function () {
  'use strict';
  if (window.__tmpgSW) return;
  window.__tmpgSW = true;

  var KEY = 'tmpg_selected_works';
  var CFG = window.TMPG_SW || {};
  var PAGE_URL = CFG.url || '/search?view=selected-works';

  var HEART = '<svg viewBox="0 0 24 24" aria-hidden="true"><path class="tsw-fill" stroke="currentColor" stroke-width="1.5" stroke-linejoin="round" d="M12 20.5s-7.5-4.6-9.3-9.2C1.5 8.1 3.4 4.5 7 4.5c2.1 0 3.6 1.2 5 3 1.4-1.8 2.9-3 5-3 3.6 0 5.5 3.6 4.3 6.8-1.8 4.6-9.3 9.2-9.3 9.2z"/></svg>';

  /* ---------- store ---------- */
  var memory = [];
  function read() {
    try {
      var raw = window.localStorage.getItem(KEY);
      var list = raw ? JSON.parse(raw) : [];
      return Array.isArray(list) ? list.filter(function (i) { return i && i.h; }) : [];
    } catch (e) { return memory.slice(); }
  }
  function write(list) {
    memory = list.slice();
    try { window.localStorage.setItem(KEY, JSON.stringify(list)); } catch (e) {}
    sync();
    try { document.dispatchEvent(new CustomEvent('tmpg:selected-works', { detail: { items: list } })); } catch (e) {}
  }
  function has(handle) { return read().some(function (i) { return i.h === handle; }); }
  function add(handle, variant) {
    var list = read();
    if (list.some(function (i) { return i.h === handle; })) {
      if (variant) { list.forEach(function (i) { if (i.h === handle) i.v = variant; }); write(list); }
      return;
    }
    list.push({ h: handle, v: variant || '', t: Date.now() });
    write(list);
  }
  function remove(handle) { write(read().filter(function (i) { return i.h !== handle; })); }
  function toggle(handle, variant) {
    if (has(handle)) { remove(handle); return false; }
    add(handle, variant); return true;
  }

  function handleFromHref(href) {
    if (!href) return null;
    var m = String(href).match(/\/products\/([^\/?#]+)/);
    return m ? decodeURIComponent(m[1]) : null;
  }
  function pageUrlWith(params) {
    var u = new URL(PAGE_URL, window.location.origin);
    Object.keys(params || {}).forEach(function (k) { u.searchParams.set(k, params[k]); });
    return u.toString();
  }

  /* ---------- toast ---------- */
  var toastEl, toastTimer;
  function toast(text, withLink) {
    if (!toastEl) {
      toastEl = document.createElement('div');
      toastEl.className = 'tsw-toast';
      toastEl.setAttribute('role', 'status');
      document.body.appendChild(toastEl);
    }
    toastEl.innerHTML = '<span></span>' + (withLink ? '<a href="' + PAGE_URL + '">View selection</a>' : '');
    toastEl.firstChild.textContent = text;
    toastEl.classList.add('is-on');
    clearTimeout(toastTimer);
    toastTimer = setTimeout(function () { toastEl.classList.remove('is-on'); }, 3200);
  }

  /* ---------- UI sync (hearts, PDP button, header count) ---------- */
  function sync() {
    var list = read();
    var set = {};
    list.forEach(function (i) { set[i.h] = true; });

    document.querySelectorAll('[data-tsw-toggle]').forEach(function (el) {
      var on = !!set[el.getAttribute('data-handle')];
      el.classList.toggle('is-selected', on);
      el.setAttribute('aria-pressed', on ? 'true' : 'false');
      if (el.classList.contains('tsw-heart')) {
        el.setAttribute('aria-label', on ? 'Remove from Selected Works' : 'Add to Selected Works');
      }
    });

    document.querySelectorAll('a[data-link-wishlist]').forEach(function (a) {
      a.setAttribute('href', PAGE_URL);
      a.setAttribute('aria-label', 'Selected Works');
      a.setAttribute('title', 'Selected Works');
    });
    document.querySelectorAll('[data-count-wishlist]').forEach(function (c) {
      c.textContent = list.length;
      c.classList.toggle('t4s-op-0', list.length === 0);
      c.style.opacity = list.length ? '1' : '';
    });
    document.querySelectorAll('[data-tsw-count]').forEach(function (c) { c.textContent = list.length; });
  }

  /* ---------- heart on product cards ---------- */
  var CARD_EXCLUDE = 'header, nav, footer, .tp-hero, .tsw-page, .t4s-mini_cart, .tmpg-nav, [data-tsw-skip]';
  function decorate(root) {
    var scope = root && root.querySelectorAll ? root : document;
    var main = document.getElementById('MainContent') || document.body;
    scope.querySelectorAll('a[href*="/products/"]').forEach(function (a) {
      if (a.dataset.tswDone) return;
      if (!main.contains(a) || a.closest(CARD_EXCLUDE)) return;
      var handle = handleFromHref(a.getAttribute('href'));
      if (!handle) return;
      var img = a.querySelector('img');
      if (!img) return;
      var host = a.querySelector('[class*="__img"]') || img.parentElement;
      if (!host) return;
      a.dataset.tswDone = '1';
      host.classList.add('tsw-host');
      var b = document.createElement('button');
      b.type = 'button';
      b.className = 'tsw-heart';
      b.setAttribute('data-tsw-toggle', '');
      b.setAttribute('data-handle', handle);
      b.setAttribute('aria-label', 'Add to Selected Works');
      b.innerHTML = HEART;
      host.appendChild(b);
    });
    sync();
  }

  /* ---------- clicks ---------- */
  document.addEventListener('click', function (e) {
    var wl = e.target.closest && e.target.closest('a[data-link-wishlist]');
    if (wl) {
      e.preventDefault(); e.stopPropagation();
      window.location.href = PAGE_URL;
      return;
    }
    var t = e.target.closest && e.target.closest('[data-tsw-toggle]');
    if (!t) return;
    e.preventDefault(); e.stopPropagation();
    var handle = t.getAttribute('data-handle');
    var variant = '';
    if (t.hasAttribute('data-tsw-variant-from')) {
      var form = document.getElementById(t.getAttribute('data-tsw-variant-from'));
      if (form) {
        var vals = [];
        form.querySelectorAll('input[type="radio"]:checked').forEach(function (r) { vals.push(r.value); });
        variant = vals.join(' / ');
      }
    }
    var on = toggle(handle, variant);
    toast(on ? 'Added to your Selected Works' : 'Removed from your Selected Works', on);
  }, true);

  window.addEventListener('storage', function (e) { if (e.key === KEY) sync(); });

  /* ---------- Selected Works page ---------- */
  function esc(s) { return String(s == null ? '' : s).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;'); }
  function money(cents, currency) {
    try { return new Intl.NumberFormat('en-US', { style: 'currency', currency: currency || 'USD', minimumFractionDigits: 0, maximumFractionDigits: 0 }).format(cents / 100); }
    catch (e) { return '$' + Math.round(cents / 100); }
  }
  function priceLabel(p, currency) {
    var por = (p.tags || []).indexOf('price-on-request') > -1 || !p.price_min;
    if (por) return 'Price on request';
    return (p.price_varies ? 'From ' : '') + money(p.price_min, currency);
  }
  function imgUrl(src, w) {
    if (!src) return '';
    if (src.indexOf('//') === 0) src = 'https:' + src;
    try { var u = new URL(src); u.searchParams.set('width', w); return u.toString(); } catch (e) { return src; }
  }
  function fetchProduct(handle) {
    return fetch('/products/' + encodeURIComponent(handle) + '.js', { credentials: 'same-origin' })
      .then(function (r) { return r.ok ? r.json() : null; })
      .catch(function () { return null; });
  }

  function initPage(root) {
    var currency = root.getAttribute('data-currency') || 'USD';
    var grid = root.querySelector('[data-tsw-grid]');
    var empty = root.querySelector('[data-tsw-empty]');
    var banner = root.querySelector('[data-tsw-banner]');
    var actions = root.querySelector('[data-tsw-actions]');
    var send = root.querySelector('[data-tsw-send]');
    var eyebrow = root.querySelector('[data-tsw-eyebrow]');
    var form = root.querySelector('form.tsw-form');
    var listField = null;
    var bodyField = root.querySelector('[data-tsw-body-field]');
    var msgField = root.querySelector('[data-tsw-message]');

    var params = new URLSearchParams(window.location.search);
    var sharedParam = params.get('works');
    var shared = sharedParam ? sharedParam.split(',').map(function (s) { return decodeURIComponent(s.trim()); }).filter(Boolean) : null;
    var sharedFrom = params.get('from') || '';
    var mode = shared && shared.length ? 'shared' : 'own';
    var products = {}; // handle -> product json

    function currentItems() {
      if (mode === 'shared') return shared.map(function (h) { return { h: h, v: '' }; });
      return read();
    }

    function render() {
      var items = currentItems();
      var n = items.length;

      if (eyebrow) eyebrow.textContent = mode === 'shared'
        ? (sharedFrom ? 'Shared by ' + sharedFrom : 'A selection shared with you')
        : (n === 1 ? '1 work' : n + ' works');

      banner.classList.toggle('tsw-hidden', mode !== 'shared');
      if (mode === 'shared') {
        var mine = read().map(function (i) { return i.h; });
        var allMine = shared.every(function (h) { return mine.indexOf(h) > -1; });
        banner.querySelector('[data-tsw-banner-text]').textContent = allMine
          ? 'All of these works are already in your Selected Works.'
          : 'Someone shared these works with you. Save them to keep them in your own Selected Works.';
        banner.querySelector('[data-tsw-save-shared]').classList.toggle('tsw-hidden', allMine);
      }

      empty.classList.toggle('tsw-hidden', n > 0);
      grid.classList.toggle('tsw-hidden', n === 0);
      actions.classList.toggle('tsw-hidden', n === 0 || mode === 'shared');
      send.classList.toggle('tsw-hidden', n === 0);

      grid.innerHTML = items.map(function (i) {
        var p = products[i.h];
        if (p === false) {
          return '<div class="tsw-item is-gone" data-h="' + esc(i.h) + '"><div class="tsw-item__img"></div><div class="tsw-item__meta"><div class="tsw-item__title">This work is no longer available</div></div>'
            + (mode === 'own' ? '<button class="tsw-item__remove" data-tsw-remove="' + esc(i.h) + '" aria-label="Remove">&times;</button>' : '') + '</div>';
        }
        if (!p) return '<div class="tsw-item" data-h="' + esc(i.h) + '"><div class="tsw-item__img"></div><div class="tsw-item__meta"><div class="tsw-item__sub">Loading…</div></div></div>';
        var src = p.featured_image ? imgUrl(p.featured_image, 700) : '';
        return '<div class="tsw-item" data-h="' + esc(i.h) + '">'
          + '<a class="tsw-item__img" href="' + esc(p.url) + '">' + (src ? '<img src="' + esc(src) + '" alt="' + esc(p.title) + '" loading="lazy">' : '') + '</a>'
          + '<div class="tsw-item__meta">'
          +   (p.vendor ? '<div class="tsw-item__artist">' + esc(p.vendor) + '</div>' : '')
          +   '<a class="tsw-item__title" href="' + esc(p.url) + '">' + esc(p.title) + '</a>'
          +   '<div class="tsw-item__sub">' + esc(priceLabel(p, currency)) + (i.v ? ' &middot; ' + esc(i.v) : '') + '</div>'
          + '</div>'
          + (mode === 'own' ? '<button class="tsw-item__remove" data-tsw-remove="' + esc(i.h) + '" aria-label="Remove ' + esc(p.title) + ' from Selected Works">&times;</button>' : '')
          + '</div>';
      }).join('');
    }

    function load() {
      var missing = currentItems().map(function (i) { return i.h; }).filter(function (h) { return !(h in products); });
      render();
      if (!missing.length) return;
      Promise.all(missing.map(function (h) {
        return fetchProduct(h).then(function (p) { products[h] = p || false; });
      })).then(render);
    }

    function listText() {
      return currentItems().map(function (i, idx) {
        var p = products[i.h];
        var title = p ? p.title : i.h;
        var line = (idx + 1) + '. ' + title + (p && p.vendor ? ' by ' + p.vendor : '');
        if (i.v) line += ' (' + i.v + ')';
        line += '\n   ' + window.location.origin + '/products/' + i.h;
        return line;
      }).join('\n');
    }
    function shareUrl() {
      return pageUrlWith({ works: currentItems().map(function (i) { return i.h; }).join(',') });
    }

    root.addEventListener('click', function (e) {
      var rm = e.target.closest('[data-tsw-remove]');
      if (rm) { remove(rm.getAttribute('data-tsw-remove')); render(); return; }

      if (e.target.closest('[data-tsw-save-shared]')) {
        shared.forEach(function (h) { add(h); });
        toast('Saved to your Selected Works', false);
        render();
        return;
      }

      var shareBtn = e.target.closest('[data-tsw-share-toggle]');
      if (shareBtn) {
        var wrap = shareBtn.closest('.tsw-share');
        var url = shareUrl();
        if (navigator.share && window.matchMedia('(hover: none)').matches) {
          navigator.share({ title: 'Selected Works — The Music Photo Gallery', text: 'A selection of works from The Music Photo Gallery', url: url }).catch(function () {});
          return;
        }
        wrap.classList.toggle('is-open');
        return;
      }

      var act = e.target.closest('[data-tsw-share]');
      if (act) {
        var kind = act.getAttribute('data-tsw-share');
        var link = shareUrl();
        var subject = 'Selected Works from The Music Photo Gallery';
        var body = 'I put together a selection of works from The Music Photo Gallery:\n\n' + listText() + '\n\nSee the full selection here:\n' + link;
        if (kind === 'copy') {
          var done = function () { toast('Link copied', false); };
          if (navigator.clipboard) navigator.clipboard.writeText(link).then(done, function () { window.prompt('Copy this link', link); });
          else window.prompt('Copy this link', link);
        } else if (kind === 'email') {
          window.location.href = 'mailto:?subject=' + encodeURIComponent(subject) + '&body=' + encodeURIComponent(body);
        } else if (kind === 'whatsapp') {
          window.open('https://wa.me/?text=' + encodeURIComponent('A selection of works from The Music Photo Gallery: ' + link), '_blank', 'noopener');
        }
        act.closest('.tsw-share').classList.remove('is-open');
        return;
      }

      if (e.target.closest('[data-tsw-goto-send]')) {
        send.scrollIntoView({ behavior: 'smooth', block: 'start' });
        var first = send.querySelector('input:not([type=hidden])');
        if (first) setTimeout(function () { first.focus({ preventScroll: true }); }, 450);
      }
    });

    document.addEventListener('click', function (e) {
      if (!e.target.closest('.tsw-share')) root.querySelectorAll('.tsw-share.is-open').forEach(function (s) { s.classList.remove('is-open'); });
    });
    document.addEventListener('tmpg:selected-works', function () { if (mode === 'own') load(); });

    if (form) {
      form.addEventListener('submit', function (e) {
        var list = listText();
        if (listField) listField.value = list;
        if (bodyField) bodyField.value = (msgField && msgField.value ? msgField.value + '\n\n' : '') + 'SELECTED WORKS (' + currentItems().length + ')\n' + list + '\n\nSelection link: ' + shareUrl();
        // Native submit on purpose: Shopify's hCaptcha (storefront forms protection)
        // must run on this form, so it cannot be posted with fetch.
        try { window.sessionStorage.setItem('tsw_sent_pending', String(Date.now())); } catch (err) {}
      });
    }

    if (params.get('sent') === '1') showSent();
    function showSent() {
      var ok = root.querySelector('[data-tsw-ok]');
      if (form) form.classList.add('tsw-hidden');
      if (ok) { ok.classList.remove('tsw-hidden'); setTimeout(function () { ok.scrollIntoView({ behavior: 'smooth', block: 'center' }); }, 300); }
      if (window.history && window.history.replaceState) window.history.replaceState(null, '', PAGE_URL);
    }

    load();
  }

  /* ---------- boot ---------- */
  function boot() {
    try {
      var sentAt = window.sessionStorage.getItem('tsw_sent_pending');
      if (sentAt && /contact_posted=true/.test(window.location.search)) {
        window.sessionStorage.removeItem('tsw_sent_pending');
        window.location.replace(pageUrlWith({ sent: '1' }));
        return;
      }
      if (sentAt && Date.now() - Number(sentAt) > 600000) window.sessionStorage.removeItem('tsw_sent_pending');
    } catch (err) {}
    decorate(document);
    var page = document.querySelector('[data-tsw-page]');
    if (page) initPage(page);
    var main = document.getElementById('MainContent');
    if (main && window.MutationObserver) {
      var queued = false;
      new MutationObserver(function () {
        if (queued) return;
        queued = true;
        requestAnimationFrame(function () { queued = false; decorate(main); });
      }).observe(main, { childList: true, subtree: true });
    }
    // Kalles re-renders its own wishlist counter after load; keep ours on top.
    setTimeout(sync, 800);
    setTimeout(sync, 2500);
  }

  window.TMPGSelectedWorks = { read: read, add: add, remove: remove, toggle: toggle, has: has, url: PAGE_URL };
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
}());
